/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
import Logo from '../../../assets/icons/logo.png';
import styles from './styles.module.scss';
import PhoneNumber from './PhoneNumber';
import ValidatePhone from './ValidatePhone';
import UserInfo from './UserInfo';

import { useMutation } from '@tanstack/react-query';

import { getVerificationCode, register, verifyCode } from './api';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Registered from './Registered';
import {
  get_now,
  get_token,
  get_user_info,
  set_token
} from '../../../helpers/api';
import { routes } from '../../../assets/routes';
import { useTranslation } from '../../../i18n/LanguageProvider';

const Register = () => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');
  const { orgId } = useParams();

  const history = useHistory();
  const sendPhoneNumberMutation = useMutation(getVerificationCode, {
    onError: (err) =>
      toast.error(err.response?.data?.detail || t('common.error')),

    onSuccess: (data) => {
      setPhoneNumber(data.data.phone_number);
      setCurrentStep(1);
    }
  });

  const verifyPhoneNumberMutation = useMutation(verifyCode, {
    onError: (err) => {
      toast.error(err.response?.data?.detail || t('common.error'));
      setCurrentStep(0);
    },

    onSuccess: (data) => {
      localStorage.setItem('register-access-toke', data.data.access_token);
      setCurrentStep(2);
    }
  });

  const registerUserMutation = useMutation(register, {
    onError: (err) =>
      toast.error(err.response?.data?.detail || t('common.error')),

    onSuccess: (data) => {
      set_token(data.data.access_token);
      if (data.data?.is_new_user) {
        history.push(routes.WELCOME);
      } else {
        history.push(routes.HOME);
      }
      toast.success(t('auth.loginSuccess'));
    }
  });

  const handleSendPhoneNumber = (phoneNumber) => {
    sendPhoneNumberMutation.mutate({
      phoneNumber
    });
  };

  const handleSendVerificationCode = (verificationCode) => {
    verifyPhoneNumberMutation.mutate({
      phoneNumber,
      verificationCode
    });
  };

  const handleRegister = (data) => {
    registerUserMutation.mutate({
      accessToken: localStorage.getItem('register-access-toke'),
      organizationId: orgId,
      firstName: data.firstName,
      lastName: data.lastName,
      password: data.password
    });
  };

  return (
    <div className={styles.page}>
      <div>
        <img src={Logo} alt="reco-logo" className={styles.logo} />
        {currentStep === 0 && <h1>{t('auth.registerWelcome')}</h1>}
      </div>

      <div className={styles.formsContainer}>
        <div className={currentStep === 0 ? styles.show : styles.hide}>
          <PhoneNumber
            onSubmitPhone={handleSendPhoneNumber}
            loading={sendPhoneNumberMutation.isLoading}
          />
        </div>
        <div className={currentStep === 1 ? styles.show : styles.hide}>
          <ValidatePhone
            getVerificationCodeAgain={handleSendPhoneNumber}
            onSubmitVerificationCode={handleSendVerificationCode}
            onCancel={() => setCurrentStep(0)}
            phoneNumber={phoneNumber}
            loading={verifyPhoneNumberMutation.isLoading}
          />
        </div>
        <div className={currentStep === 2 ? styles.show : styles.hide}>
          <UserInfo onSubmitUser={handleRegister} />
        </div>

        <div className={currentStep === 3 ? styles.show : styles.hide}>
          <Registered />
        </div>
      </div>
    </div>
  );
};

export default Register;
